import React from 'react'
import styled from 'styled-components'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import Breadcrumbs_ from '@mui/material/Breadcrumbs'
import Tab_ from '@mui/material/Tab'
import MuiDrawer from '@mui/material/Drawer'
import MuiAppBar from '@mui/material/AppBar'

export const Title = styled(Typography).attrs({
  variant: 'h6',
  noWrap: true,
})`
  padding: 0 ${({ theme }) => theme.spacing(2)};
`

export function MenuIconButton(props) {
  return (
    <IconButton edge="start" color="inherit" aria-label="menu" {...props}>
      <MenuIcon />
    </IconButton>
  )
}

export const Breadcrumbs = styled(Breadcrumbs_).attrs({
  dir: 'rtl',
  style: {
    direction: 'rtl',
    textAlign: 'right',
  },
})(({ theme }) => `
  flex: 1 1 auto;
  min-width: 0;
  padding: 0 ${theme.spacing(4)}px;
  overflow: hidden;
  white-space: nowrap;

  .MuiBreadcrumbs-ol {
    flex-wrap: nowrap;
    overflow: hidden;
  }

  .MuiBreadcrumbs-li {
    min-width: 0;
    white-space: nowrap;
  }

  .MuiBreadcrumbs-separator {
    flex: 0 0 auto;
  }

  a,
  span,
  p {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  p {
    /* Inherit the AppBar text color (dark on the light-gray bar, #177). */
    color: inherit !important;
  }

  /* Always keep the current (last) crumb fully visible — it's the most useful,
     and on a phone the earlier crumbs truncate to almost nothing otherwise. */
  .MuiBreadcrumbs-li:last-child {
    flex: 0 0 auto;
  }
  .MuiBreadcrumbs-li:last-child a,
  .MuiBreadcrumbs-li:last-child span,
  .MuiBreadcrumbs-li:last-child p {
    max-width: none;
    overflow: visible;
    text-overflow: clip;
  }

  /* On phones let the trail wrap onto up to two lines (fits within the 56px
     toolbar) so more crumbs stay readable instead of collapsing to one char. */
  @media (max-width: 600px) {
    white-space: normal;

    .MuiBreadcrumbs-ol {
      flex-wrap: wrap;
      max-height: 3em;
      overflow: hidden;
    }
  }
`)

export const Tab = styled(Tab_)`
  a {
    color: color(255,255,255,0.87);
  }
`

export const Drawer = styled(MuiDrawer).attrs({
  anchor: 'left',
})``

// Client feedback (#177): the brand green was too dominant as the bar color —
// the top bar is light gray with dark text; the green stays for actions/links.
export const AppBar = styled(MuiAppBar)`
  && {
    background-color: #f2f4f6;
    color: #1b1b1b;
  }

  @media print {
    display: none !important;
  }
`